// #region Imports

import { ApiServiceBase } from './apiServiceBase';
import { INoteData } from '../dto/INoteData';
import { sendEvent } from '../modules/helpers/Analytics';

// #endregion Imports

export class NoteService extends ApiServiceBase {
    private apiUrl = '/api/notes/1.0';
    private categoryUrl = '/api/notecategories/1.0';

    createNote(note: INoteData, onSuccess: (response: any) => void, onFailure: (response: any) => void): JQuery.jqXHR {
        this.setForcedReload();
        return this.post(this.apiUrl, onSuccess, onFailure, note);
    }

    updateNote(note: INoteData, onSuccess: (response: any) => void, onFailure: (response: any) => void): JQuery.jqXHR {
        if (note.title || note.text) {
            sendEvent('createNote', undefined, { pageId: note.pageId, color: note.color, pageTitle: note.pageHeading })
        }
        this.setForcedReload();
        return this.put(`${this.apiUrl}/${note.id}`, onSuccess, onFailure, note);
    }

    updateCategoryForNote(noteId, categoryId): void {
        this.get(`${this.apiUrl}/updatecategory?id=${noteId}&categoryId=${categoryId}`, () => {}, () => {});
    }

    getNotes(onSuccess: (response: any) => void, onFailure: (response: any) => void, colors?: string[]): JQuery.jqXHR {
        let url = this.apiUrl;
        if (colors && colors.length > 0) {
            url += '?colors=' + colors.join(',');
        }
        return this.get(url, onSuccess, onFailure);
    }

    getFilteredNotes(filter: string, onSuccess: (response: any) => void, onFailure: (response: any) => void, colors?: string[]): JQuery.jqXHR {
        let url = this.apiUrl + '?filter=' + encodeURIComponent(filter);
        if (colors && colors.length > 0) {
            url += '&colors=' + colors.join(',');
        }
        return this.get(url, onSuccess, onFailure);
    }

    getFilteredNotesByCategory(filter: string, onSuccess: (response: any) => void, onFailure: (response: any) => void, colors?: string[]): JQuery.jqXHR {
        let url = this.apiUrl + '/category?filter=' + encodeURIComponent(filter);
        if (colors && colors.length > 0) {
            url += '&colors=' + colors.join(',');
        }
        return this.get(url, onSuccess, onFailure);
    }

    getNoteCategories(onSuccess: (response: any) => void, onFailure: (response: any) => void, colors?: string[]): JQuery.jqXHR {
        let url = this.apiUrl + '/category';
        if (colors && colors.length > 0) {
            url += '?colors=' + colors.join(',');
        }
        return this.get(url, onSuccess, onFailure);
    }

    getPinnedNotesForUser(onSuccess: (response: any) => void, onFailure: (response: any) => void): JQuery.jqXHR {
        return this.get(`${this.apiUrl}/pinned`, onSuccess, onFailure);
    }

    togglePinnedNote(noteId, isPinned, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.put(`${this.apiUrl}/pinned/${noteId}/${isPinned}`, onSuccess, onFailure,);
    }

    pinNote(noteId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.put(`${this.apiUrl}/pin/${noteId}`, onSuccess, onFailure,);
    }

    unPinNote(noteId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.put(`${this.apiUrl}/unpin/${noteId}`, onSuccess, onFailure,);
    }

    deleteNoteById(bookmarkId, onSuccess: (response: any) => void, onFailure: (response: any) => void): JQuery.jqXHR {
        this.setForcedReload();
        return this.delete(`${this.apiUrl}/${bookmarkId}`, onSuccess, onFailure);
    }

    setForcedReload(): void {
        if (typeof ((window as any).unloadNotes) !== 'undefined') {
            (window as any).unloadNotes();
        }
    }

    editCategory(category, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.put(`${this.categoryUrl}/${category.categoryId}`, onSuccess, onFailure, category);
    }

    deleteCategory(category, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.delete(`${this.categoryUrl}/${category.categoryId}`, onSuccess, onFailure);
    }

    createCategory(category, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        sendEvent('createNotesCategory', undefined, undefined)
        this.post(this.categoryUrl, onSuccess, onFailure, category);
    }

    updateSortOrder(
        noteIds: string[],
        onSuccess: (response: any) => void,
        onFailure: (response: any) => void
    ) {
        const formData = new FormData();
        noteIds.forEach((id) => formData.append("referenceIds", id));

        fetch(`${this.apiUrl}/updatesortorder`, {
            method: "PUT",
            body: formData,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to update sort order!!");
                }
                return response.json();
            })
            .then(onSuccess)
            .catch(onFailure);
    }
}